import { ArrowUp, Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_HREF } from "../lib/site";

const LINKS = [
  { label: "Pricing", href: "/pricing", id: "pricing" },
  { label: "Service Area", href: "/service-area", id: "service-area" },
  { label: "Reviews", href: "/reviews", id: "reviews" },
];

export const Navbar = () => (
  <header
    data-testid="site-navbar"
    className="fixed top-0 inset-x-0 z-50 bg-[#050505]/85 backdrop-blur-xl border-b border-white/10"
  >
    <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 flex items-center justify-between gap-4">
      <a href="#top" onClick={(e) => { e.preventDefault(); window.__lenis ? window.__lenis.scrollTo(0) : window.scrollTo(0, 0); }}
        data-testid="navbar-brand" className="flex items-center gap-3 group">
        <img src="/images/logo-mark.png" alt="Tru North logo" className="w-9 h-9 mix-blend-screen transition-transform duration-300 group-hover:-translate-y-0.5" />
        <span className="leading-none">
          <span className="block font-display font-bold uppercase tracking-wide text-sm">Tru North</span>
          <span className="block font-mono text-[10px] tracking-[0.25em] text-neutral-400 uppercase">Towing &amp; Recovery</span>
        </span>
      </a>

      <nav className="hidden md:flex items-center gap-8">
        {LINKS.map((l) => (
          <a
            key={l.id}
            href={l.href}
            data-testid={`nav-link-${l.id}`}
            className="font-mono text-xs uppercase tracking-[0.2em] text-neutral-400 transition-colors duration-200 hover:text-primary"
          >
            {l.label}
          </a>
        ))}
        <a
          href="/about"
          data-testid="nav-link-about"
          className="font-mono text-xs uppercase tracking-[0.2em] text-neutral-400 transition-colors duration-200 hover:text-primary"
        >
          About
        </a>
      </nav>

      <div className="flex items-center gap-3">
        <a
          data-testid="navbar-phone-link"
          href={PHONE_HREF}
          className="hidden lg:flex items-center gap-2 font-mono text-xs text-neutral-300 transition-colors duration-200 hover:text-primary"
        >
          <Phone size={14} /> {PHONE_DISPLAY}
        </a>
        <a data-testid="navbar-get-help-btn" href={PHONE_HREF} className="btn-primary !px-5 !py-2.5 text-xs">
          <Phone size={14} /> Get Help Now
        </a>
      </div>
    </div>
  </header>
);
